import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/development-commitments/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentCommitmentsPath = "/development-commitments";
export const developmentCommitmentsRoute = defineRoute(developmentCommitmentsPath);
export const developmentCommitmentRoute = defineRoute(`${developmentCommitmentsPath}/:developmentCommitmentId`);

export const developmentCommitmentsPaths = {
  developmentCommitments: developmentCommitmentsPath,
  developmentCommitment: developmentCommitmentRoute.path,
};
